import React from 'react';

import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { useValuesVisibility } from '../../hooks/useValuesVisibility';

export function ToggleButton() {
  const { valuesVisibility, toggle } = useValuesVisibility();

  const valuesIsVisible = valuesVisibility === 'visible';

  return (
    <Button
      className='align-center border border-[#DDDDDD] bg-white text-[#212121] hover:bg-[#EEEEEE] hover:shadow-none disabled:bg-[#eee] max-md:mt-2'
      icon={
        valuesIsVisible ? (
          <EyeInvisibleOutlined style={{ fontSize: 20, paddingTop: 4 }} />
        ) : (
          <EyeOutlined style={{ fontSize: 20 }} />
        )
      }
      onClick={toggle}
      aria-pressed={valuesIsVisible}
    >
      {`${valuesIsVisible ? 'Esconder' : 'Exibir'} valores`}
    </Button>
  );
}
